export default __webpack_public_path__ + "static/media/wanderruf.6111e135.jpeg";